import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChatDetailLayout, ChatFooter, ChatHeader, ChatMessages, type PendingMessage } from 'features/chat';
import { useChatroomsSearchParams, useNavigateToChat, useNavigateToChatroom, useNavigateToCreateChat } from '../hooks';
import { useChatDetailLocationState, useClearPendingMessageFromLocation } from './hooks';

export type ChatDetailLocationState = {
  pendingMessage?: PendingMessage;
};

const PageChatDetail = () => {
  const { chatId } = useRequiredParams<{ chatId: string }>();
  const { state } = useChatDetailLocationState();
  const clearPendingMessageFromLocation = useClearPendingMessageFromLocation();
  const navigateToChat = useNavigateToChat();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();
  const navigateToChatroom = useNavigateToChatroom();

  return (
    <AppLayout fitCenterContent>
      <ChatDetailLayout
        footer={(chatroomId) => <ChatFooter chatroomId={chatroomId} />}
        header={(chatroom) => <ChatHeader chatroom={chatroom} onChatDeleted={navigateToChat} />}
        id={chatId}
        onChatDeleted={navigateToChat}
        onChatRoomClicked={navigateToChatroom}
        onCreateChatClicked={navigateToCreateChat}
        searchParamsOptions={searchParamsOptions}
      >
        {({ chatroom }) => (
          <ChatMessages
            chatroom={chatroom}
            key={chatroom.id}
            onPendingMessageConsumed={clearPendingMessageFromLocation}
            pendingMessage={state?.pendingMessage}
          />
        )}
      </ChatDetailLayout>
    </AppLayout>
  );
};

export default PageChatDetail;
